import { FC } from 'react'

import { ISvgClass } from '../interface'

const ArrowdownIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      fill="none"
      height="24"
      shape-rendering="geometricPrecision"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      viewBox="0 0 24 24"
      width="24"
      {...props}
    >
      <path d="M6 9l6 6 6-6" fill="inherit" />
    </svg>
  )
}

export default ArrowdownIcon
